import React, { useState, useEffect, useMemo } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import redirectURL from "../redirectURL";
// import "../assets/css/inventorymanagement.css";

const DarkstoreConfigurations = () => {
    const [loadshow, setLoadshow] = useState("show-n");
    const [overlayBlock, setOverlayBlock] = useState("show-n");
    const [overlyBlock, setOverlyBlock] = useState("show-n");

    const [show, setShow] = useState(false);
    const [basicTitle, setBasicTitle] = useState("");
    const [basicType, setBasicType] = useState("default");

    const [isSliderOpen, setIsSliderOpen] = useState(false);
    const [sliderType, setSliderType] = useState(null);
    const [sliderCl, setSliderCl] = useState("slider-25");
    const [sliderTitle, setSliderTitle] = useState("");

    const [rowData, setRowData] = useState([]);
    const [columnWithDefs, setColumnWithDefs] = useState([]);
    
    const [editFormData, setEditFormData] = useState({
        id: "",
        destination_store_id: "",
        destination_store_name: "",
        destination_type: "",
        cycle_period: ""
    });

    const [duplicatedEditData, setDuplicatedEditData] = useState({
        id: "",
        destination_store_id: "",
        destination_store_name: "",
        destination_type: "",
        cycle_period: ""
    });

    // Action column renderer for Edit button
    const actionCellRenderer = (params) => {
        return (
            <div style={{
                height: "36px", 
                padding: 0, 
                display: "flex", 
                justifyContent: "center", 
                alignItems: "center"
            }}>
                <button
                    title="Edit"
                    className="mt-2"
                    style={{
                        height: "30px", 
                        width: "60px",
                        padding: "0 10px",
                        border: "1px solid #93385D",
                        borderRadius: "4px",
                        cursor: "pointer",
                        backgroundColor: "#F4EBEF",
                        fontSize: "0.8rem",
                        color: "#93385D",
                    }}
                    onClick={() => handleEdit(params.data)}
                >
                    Edit
                </button>
            </div>
        );
    };

    const darkstoreCols = useMemo(() => [
        {
            headerName: "",
            field: "actions",
            sortable: false,
            filter: false,
            width: "90px",
            cellClass: "custom-cell", 
            cellRenderer: actionCellRenderer,
        },
        { 
            headerName: "Destination Store ID", 
            field: "destination_store_id",
            width: 180
        },
        { 
            headerName: "Destination Store Name", 
            field: "destination_store_name",
            width: 200
        },
        // { 
        //     headerName: "Destination Type", 
        //     field: "destination_type",
        //     width: 150
        // },
        { 
            headerName: "Cycle Period", 
            field: "cycle_period",
            width: 130,
            cellStyle: { 'text-align': 'center' }
        }
    ], []);

    const defaultColDef = useMemo(() => ({
        sortable: true,
        filter: true,
        pivot: true,
        enableValue: true,
        enableRowGroup: true,
        resizable: true,
    }), []);

    const sideBar = useMemo(() => ({
        toolPanels: [
            { id: "columns", labelDefault: "Columns", labelKey: "columns", iconKey: "columns", toolPanel: "agColumnsToolPanel" },
            { id: "filters", labelDefault: "Filters", labelKey: "filters", iconKey: "filter", toolPanel: "agFiltersToolPanel" },
        ],
    }), []);

    const statusPanel = useMemo(() => ({
        statusPanels: [
            { statusPanel: "agTotalAndFilteredRowCountComponent", align: "left" },
            { statusPanel: "agTotalRowCountComponent", align: "center" },
            { statusPanel: "agFilteredRowCountComponent" },
            { statusPanel: "agSelectedRowCountComponent" },
            { statusPanel: "agAggregationComponent" },
        ],
    }), []);

    // Reset form data
    const resetFormData = () => {
        setEditFormData({ 
            id: "",
            destination_store_id: "",
            destination_store_name: "",
            destination_type: "",
            cycle_period: ""
        });
        setDuplicatedEditData({
            id: "",
            destination_store_id: "",
            destination_store_name: "",
            destination_type: "",
            cycle_period: ""
        });
    };

    const handleEdit = (row) => {
        setEditFormData({
            id: row._id || row.id,
            destination_store_id: row.destination_store_id || "",
            destination_store_name: row.destination_store_name || "",
            destination_type: row.destination_type || "",
            cycle_period: row.cycle_period || ""
        });
        setDuplicatedEditData({
            id: row._id || row.id,
            destination_store_id: row.destination_store_id || "",
            destination_store_name: row.destination_store_name || "",
            destination_type: row.destination_type || "",
            cycle_period: row.cycle_period || ""
        });
        setIsSliderOpen(true);
        setSliderType(2);
        setSliderCl("slider-25");
        setOverlyBlock("show-m");
        setSliderTitle("Edit Cycle Period");
    };

    const closeSlider = () => {
        setIsSliderOpen(false);
        setSliderType(null);
        setOverlayBlock("show-n");
        setOverlyBlock("show-n");
        resetFormData();
    };

    const onClickingSliderCloseIcon = () => {
        setOverlyBlock("show-n");
        setIsSliderOpen(false);
        resetFormData();
    };

    const hideOverlySlideBlock = () => {
        setIsSliderOpen(false);
        setLoadshow("show-n");
        setOverlyBlock("show-n");
        resetFormData();
    };

    const closeAlert = () => {
        setShow(false);
        setIsSliderOpen(false);
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setOverlyBlock("show-n");
    };

    const getDarkstoreConfigurations = async () => {
        try {
            const response = await redirectURL.post("masters/getDarkstoreConfigurations", {});
            const data = response?.data?.data || [];
            setRowData(Array.isArray(data) ? data : []);
            setColumnWithDefs(darkstoreCols);
        } catch (err) {
            console.error("Error fetching darkstore configurations:", err);
            setRowData([]);
            setColumnWithDefs(darkstoreCols);
            setShow(true);
            setBasicType("error");
            setBasicTitle("Failed to fetch darkstore configurations");
        }
    };

    const getMainData = async () => {
        setLoadshow("show-m");
        setOverlayBlock("show-m");
        await getDarkstoreConfigurations();
        setLoadshow("show-n");
        setOverlayBlock("show-n");
    };

    useEffect(() => {
        getMainData();
    }, []);

    // Function To Trigger User Action
    const triggerUserAction = (trigerdata) => {
        redirectURL.post('inventory/triggerUserAction', trigerdata)
    }

    const onUpdateCyclePeriod = async () => {
        const { id, destination_store_id, cycle_period } = editFormData;
        
        if (!id) {
            setShow(true);
            setBasicType("error");
            setBasicTitle("Invalid record ID for update.");
            return;
        }

        if (!cycle_period) {
            setShow(true);
            setBasicType("warning");
            setBasicTitle("Please enter cycle period.");
            return;
        }

        // Check if any changes were made
        const isNeedtoUpdate = duplicatedEditData.cycle_period !== editFormData.cycle_period;

        if (!isNeedtoUpdate) {
            setShow(true);
            setBasicType("info");
            setBasicTitle("No changes made to cycle period");
            return;
        }

        // Validate cycle period
        const cyclePeriodNum = parseInt(cycle_period);
        if (isNaN(cyclePeriodNum) || cyclePeriodNum < 1 || cyclePeriodNum > 30) {
            setShow(true);
            setBasicType("warning");
            setBasicTitle("Cycle Period must be a number between 1 and 30.");
            return;
        }

        try {
            setLoadshow("show-m");
            setOverlayBlock("show-m");

            const payload = {
                id,
                destination_store_id,
                cycle_period: cyclePeriodNum
            };

            const resp = await redirectURL.post("masters/updateCyclePeriod", payload);

            if (resp?.data?.status === "success") {
                setShow(true); 
                setBasicType("success"); 
                setBasicTitle("Cycle period updated successfully.");
                closeSlider();
                await getMainData();
                const userData = {
                    email: localStorage.getItem("email"),
                    user_code: localStorage.getItem("user_code"),
                    action: "Updated Cycle period - Darkstore Configuration",
                    status: "Success",
                    path: window.location.pathname
                  };
                triggerUserAction(userData);
            } else {
                setShow(true);
                setBasicType("warning");
                setBasicTitle(resp?.data?.message || "Update failed");
                const userData = {
                    email: localStorage.getItem("email"),
                    user_code: localStorage.getItem("user_code"),
                    action: "Updated Cycle period - Darkstore Configuration",
                    status: "Warning",
                    path: window.location.pathname
                  };
                triggerUserAction(userData);
            }
        } catch (err) {
            console.error("Update cycle period error:", err);
            setShow(true);
            setBasicType("error");
            setBasicTitle(err?.response?.data?.message || "Update failed");
            const userData = {
                email: localStorage.getItem("email"),
                user_code: localStorage.getItem("user_code"),
                action: "Updated Cycle period - Darkstore Configuration",
                status: "Error",
                path: window.location.pathname
              };
            triggerUserAction(userData);
        } finally {
            setLoadshow("show-n");
            setOverlayBlock("show-n");
        }
    };

    return (
        <>
            <div className="container-fluid mt-3">
                <div style={{ zIndex: "9999999" }}>
                    <SweetAlert
                        show={show}
                        type={basicType}
                        title={basicTitle}
                        onConfirm={closeAlert}
                        style={{ fontSize: "9px" }}
                    >
                    </SweetAlert>
                </div>

                <div className="row" style={{ fontSize: "0.9rem", fontFamily: "Arial, sans-serif" }}>
                    {/* <div className="col-sm-12 p-0">
                        <h1 className="col-sm-12" style={{ 
                            color: "#B9366D", 
                            fontSize: "18px", 
                            fontWeight: "bold", 
                            fontFamily: "sans-serif",
                            marginBottom: "20px"
                        }}>
                            Darkstore Configurations
                        </h1>
                    </div> */}

                    <div className="col-sm-12 p-0 pl-2">
                        <div className="ag-theme-alpine" style={{ height: 500, width: "100%" }}>
                            <AgGridReact
                                rowData={rowData}
                                columnDefs={columnWithDefs}
                                defaultColDef={defaultColDef}
                                domLayout="normal"
                                sideBar={sideBar}
                                statusBar={statusPanel}
                                pagination
                                paginationPageSize={100}
                                enableRangeSelection
                                gridOptions={{ suppressHorizontalScroll: false }}
                            />
                        </div>
                    </div>
                </div>
            </div>

            {/* Slider for Edit */}
            <div
                className={`stock-status-slider ${isSliderOpen ? "open" : ""} ${sliderCl}`}
                style={{ width: "25%" }}
            >
                <div className="slider-header-container d-flex justify-content-between">
                    <p className="m-0p">{sliderTitle}</p>
                    <p
                        className="m-0p"
                        style={{ cursor: "pointer" }}
                        onClick={onClickingSliderCloseIcon}
                    >
                        X&nbsp;&nbsp;&nbsp;
                    </p>
                </div>

                {sliderType === 2 && (
                    <div className="panel-body" style={{ padding: "16px 20px", flex: 1, overflowY: "auto" }}>
                        <div className="form-field" style={{ marginBottom: 16 }}>
                            <label style={{ display: "block", fontWeight: 600, marginBottom: 6 }}>
                                Destination Store ID
                            </label>
                            <input
                                type="text"
                                value={editFormData.destination_store_id}
                                style={{ width: "100%", height: 44, border: "1px solid #e5e7eb", borderRadius: 8, padding: "0 12px", backgroundColor: "#f5f5f5" }}
                                disabled
                            />
                        </div>

                        <div className="form-field" style={{ marginBottom: 16 }}>
                            <label style={{ display: "block", fontWeight: 600, marginBottom: 6 }}>
                                Destination Store Name
                            </label>
                            <input
                                type="text"
                                value={editFormData.destination_store_name}
                                style={{ width: "100%", height: 44, border: "1px solid #e5e7eb", borderRadius: 8, padding: "0 12px", backgroundColor: "#f5f5f5" }}
                                disabled
                            />
                        </div>

                        {/* <div className="form-field" style={{ marginBottom: 16 }}>
                            <label style={{ display: "block", fontWeight: 600, marginBottom: 6 }}>
                                Destination Type
                            </label>
                            <input
                                type="text"
                                value={editFormData.destination_type}
                                style={{ width: "100%", height: 44, border: "1px solid #e5e7eb", borderRadius: 8, padding: "0 12px", backgroundColor: "#f5f5f5" }}
                                disabled
                            />
                        </div> */}

                        <div className="form-field" style={{ marginBottom: 16 }}>
                            <label style={{ display: "block", fontWeight: 600, marginBottom: 6 }}>
                                Cycle Period <span style={{ color: "red" }}>*</span>
                            </label>
                            <input
                                type="number"
                                value={editFormData.cycle_period}
                                onChange={(e) => setEditFormData({ ...editFormData, cycle_period: e.target.value })}
                                style={{ width: "100%", height: 44, border: "1px solid #e5e7eb", borderRadius: 8, padding: "0 12px" }}
                                placeholder="Enter cycle period (1-30)"
                                min="1"
                                max="30"
                            />
                        </div>

                        <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 16 }}>
                            <button
                                onClick={onUpdateCyclePeriod}
                                style={{
                                    padding: "10px 18px",
                                    border: 0,
                                    borderRadius: 8,
                                    cursor: "pointer",
                                    fontWeight: 700,
                                    color: "#fff",
                                    background: "#8a2d45",
                                }}
                            >
                                UPDATE
                            </button>
                        </div>
                    </div>
                )}
            </div>

            <div className={`loader ${loadshow}`} style={{ zIndex: "1002" }}></div>
            <div style={{ zIndex: 997 }} className={`overlay-block ${overlayBlock}`}></div>

            <div
                className={"overly-block " + overlyBlock}
                onClick={hideOverlySlideBlock}
            ></div>
        </>
    );
};

export default DarkstoreConfigurations;